/**
 * Tracking Code Enums
 *
 * Enums for partner tracking and attribution.
 * Issue #313 - Centralize enums to shared-types
 */

import { z } from 'zod';

// ============================================================================
// TRACKING CODE STATUS
// ============================================================================

/**
 * Tracking code lifecycle status
 * Values match database: ACTIVE, INACTIVE, EXPIRED (uppercase)
 */
export enum TrackingCodeStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
}

/** Zod schema for TrackingCodeStatus validation */
export const TrackingCodeStatusSchema = z.nativeEnum(TrackingCodeStatus);

/** Array of all tracking code statuses for iteration */
export const TRACKING_CODE_STATUSES = Object.values(TrackingCodeStatus);

// ============================================================================
// TRACKING SOURCE TYPE
// ============================================================================

/**
 * Source type for tracking codes
 * Must match API schema in crm.schema.ts
 */
export enum TrackingSourceType {
  PARTNER = 'partner',
  AFFILIATE = 'affiliate',
  INFLUENCER = 'influencer',
  CAMPAIGN = 'campaign',
  REFERRAL = 'referral',
  EMPLOYEE = 'employee',
}

/** Zod schema for TrackingSourceType validation */
export const TrackingSourceTypeSchema = z.nativeEnum(TrackingSourceType);

/** Array of all tracking source types for iteration */
export const TRACKING_SOURCE_TYPES = Object.values(TrackingSourceType);
